import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-semibold tracking-tight transition-[background-color,color,border-color,box-shadow,transform] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 active:translate-y-[1px] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-gold text-ink shadow-sm hover:bg-gold-hover",
        destructive:
          "bg-red-600 text-white shadow-sm hover:bg-red-700",
        outline:
          "border border-ink/25 bg-white text-ink shadow-sm hover:bg-cream hover:border-ink/40",
        secondary:
          "bg-cream text-ink border border-hair shadow-sm hover:bg-gold-soft",
        ghost: "text-ink hover:bg-cream",
        link: "text-gold-deep underline-offset-4 hover:underline rounded-md",
      },
      size: {
        default: "h-11 px-5 md:h-9 md:px-4",
        sm: "h-9 rounded-full px-3.5 text-xs md:h-8",
        lg: "h-12 rounded-full px-8 md:h-11",
        icon: "h-11 w-11 md:h-9 md:w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
